import 'react-app-polyfill/stable';
import {createRoot} from 'react-dom/client';
import App from './containers/App';
import {HashRouter, Routes, Route} from 'react-router-dom';
import {Provider} from 'react-redux';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import store from './configureStore';
import './css/index.css';
import {normalizeHashEncodedQueryBeforeBoot} from './helpers/normalizeHashEncodedQueryBeforeBoot';

// wiki - https://tanstack.com/query/v4/docs/react/guides/important-defaults
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnMount: false, // Disable query refetch on component mount
      refetchOnWindowFocus: false, // Disable query refetch when window regains focus
      retry: false, // Disable retry attempts for failed queries
      staleTime: Infinity, // Set query results to never be considered stale
      gcTime: Infinity, // Keep in cache indefinitely during session
      retryOnMount: false, // Don't retry failed queries when new components mount
    },
    mutations: {
      retry: false, // Disable retrying mutations on failure
    },
  },
});

// checks every 10ms to see if config is loaded.
// loads reactdom after config is loaded.
const interval = setInterval(function() {
  if (window.REACT_APP_MEMBER_API_HOST) {
    normalizeHashEncodedQueryBeforeBoot();
    const container = document.getElementById('root');
    const root = createRoot(container);
    root.render(
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <HashRouter>
            <Routes>
              <Route path="*" element={<App />} />
            </Routes>
          </HashRouter>
        </QueryClientProvider>
      </Provider>
    );
    clearInterval(interval);
  }
}, 10);
